import Difficulties from "./Difficulties";

const DifficultyMap = {
  [Difficulties.EASY]: "Easy",
  [Difficulties.MEDIUM]: "Medium",
  [Difficulties.HARD]: "Hard",
  [Difficulties.VERY_HARD]: "Very hard",
};

export default DifficultyMap;
